/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const fr_contact_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tu as une question, un projet ou simplement envie de discuter ? N'hésite pas à me contacter via le formulaire ci-dessous. Je suis là pour t'aider à concrétiser tes idées et répondre à tes besoins.`)
};

const en_contact_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Have a question, a project, or just want to chat? Feel free to reach out using the form below. I'm here to help bring your ideas to life and answer your needs.`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const contact_description = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.contact_description(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("contact_description", locale)
	if (locale === "fr") return fr_contact_description(inputs)
	return en_contact_description(inputs)
};